import {IMenu} from "../../redux/initState/InterfacesState";
import {EnumUrlsPages} from "../Enum";
import {AddMenu} from "../../components/Header/MenuPopupDeliveryAdd/constants";
import {DeliveryList} from "../../components/Header/MenuPopupDelivery/constants";

export const cities = [
  { text: 'Москва', link: 'https://lk.dalli-service.com/login.php', intoLink: true },
  { text: 'Санкт-Петербург', link: 'https://spblk.dalli-service.com/login.php', intoLink: true },
];

export const menuServicesList: IMenu[][] = [
  [{ link: EnumUrlsPages.delivery, text: 'Все услуги' }],
  [
    { text: 'Доставка Next Day', link: `${EnumUrlsPages.deliveryNextDay}`, hash: true },
    { text: 'Доставка Same Day', link: EnumUrlsPages.deliverySameDay },
    { text: 'Доставка на маркетплейсы', link: `${EnumUrlsPages.deliveryMarketplace}` },
    { text: 'Доставка в ПВЗ', link: `${EnumUrlsPages.deliveryPVZ}` },
    { text: 'Ship from store', link: `${EnumUrlsPages.deliveryShipFromStore}` },
    // { text: 'Доставка Почтой России', link: `${EnumUrlsPages.delivery}#ru`, hash: true },
    { text: 'Доставка для интернет-магазинов', link: `${EnumUrlsPages.deliveryInternet}`},
    { text: 'Доставка B2B', link: `${EnumUrlsPages.deliveryB2B}`},
    { text: 'Доставка для юридических лиц', link: `${EnumUrlsPages.deliveryForLegal}` },
  ],
  AddMenu,
];

export const menuDeliveryList: IMenu[][] = [
  [
    { text: 'География доставки', link: '' },
    { text: 'Доставка по Москве и МО', link: EnumUrlsPages.deliveryMsk },
    { text: 'Доставка по Санкт-Петербургу и ЛО', link: EnumUrlsPages.deliverySpb },
    { text: 'Доставка из Москвы в СПб и ЛО', link: EnumUrlsPages.deliveryMskToSpb },
    { text: 'Доставка в Центральный ФО', link: EnumUrlsPages.deliveryCFO },
    { text: 'Доставка в Северо-Западный ФО', link: EnumUrlsPages.deliverySZFO },
    { text: 'Доставка в Приволжский ФО', link: EnumUrlsPages.deliveryPFO },
    { text: 'Доставка в Южный ФО', link: EnumUrlsPages.deliveryUFO },
    { text: 'Доставка в Уральский ФО', link: EnumUrlsPages.deliveryUrFO },
    { text: 'Доставка в Сибирский ФО', link: EnumUrlsPages.deliverySbFO },
    { text: 'Доставка в Северо-Кавказский ФО', link: EnumUrlsPages.deliverySK },
  ],
  AddMenu,
]

export const menuTeamList: IMenu[][] = [
  [
    { text: 'О нас', link: EnumUrlsPages.about },
    { text: 'Работа в Dalli', link: EnumUrlsPages.vacancies },
    { text: 'Отзывы', link: EnumUrlsPages.reviews },
  ],
];

export default {
  textCity1: 'Москва',
  textCity1Number: '+7 (495) 646-86-82',
  textCity2: 'Петербург',
  textCity2Number: '+7 (812) 603-86-86',
  textWorkSchedule: ' 09:00–22:00 без выходных',
  textTracking: 'Отслеживание',
  textModalFeedback: 'Обратная связь',
  textBecomePartner: 'Стать партнером',
  textCabinet: 'Личный кабинет',
  textMenu: 'Меню',
  textButtonSendForm: 'Отправить заявку',
  textsMenu: {
    main: 'Главная',
    services: 'Услуги',
    tariffs: 'Тарифы',
    team: 'Команда Dalli',
    delivery: 'География доставки',
    live: 'Блог',
    contacts: 'Контакты',
    cabinet: 'Личный кабинет',
    cityMoscow: 'Москва',
    cityPetersburg: 'Санкт-Петербург'
  },
  cities,
  menuServicesList,
  menuDeliveryList,
  menuTeamList
}
